import { Component } from '@angular/core';
import { Account } from '@contracts/interfaces/account.interface';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent {
  accounts: Account[] = [];
  activeTab: string | null = null;
  
  constructor(private accountService: AccountService) { }

  ngOnInit(): void {
    this.switchCategory("business-account");

    this.accountService.find().subscribe((accounts: any) => {
      this.accounts = accounts;
    })
  }
  
  switchCategory(tab: string) {
    this.activeTab = tab;
  }

}
